import { render, staticRenderFns } from "./IndicadorPlazosCobros.vue?vue&type=template&id=6ef7324c&"
import script from "./IndicadorPlazosCobros.vue?vue&type=script&lang=js&"
export * from "./IndicadorPlazosCobros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports